export default __webpack_public_path__ + "media/components/Pay/Index/Images/mir-549b9a2fa2e370e648ec8db65bfe4c88.svg";